import { I18nLanguages } from '../types/i18n';

export const languages = {
  en: {
    name: 'English',
    englishName: 'English',
    shortLangPrefix: 'en',
    i18nKey: 'en',
    urlLangPrefix: '',
    languageId: 'EN'
  },
  fr: {
    name: 'Français',
    englishName: 'French',
    shortLangPrefix: 'fr',
    i18nKey: 'fr-FR',
    urlLangPrefix: 'fr/',
    languageId: 'FR'
  },
  de: {
    name: 'Deutsch',
    englishName: 'German',
    shortLangPrefix: 'de',
    i18nKey: 'de',
    urlLangPrefix: 'de/',
    languageId: 'DE'
  },
  ja: {
    name: '日本語',
    englishName: 'Japanese',
    shortLangPrefix: 'ja',
    i18nKey: 'ja',
    urlLangPrefix: 'ja/',
    languageId: 'JA'
  },
  'pt-br': {
    name: 'Português',
    englishName: 'Portuguese',
    shortLangPrefix: 'pt',
    i18nKey: 'pt-BR',
    urlLangPrefix: 'pt/',
    languageId: 'PT_BR'
  },
  es: {
    name: 'Español',
    englishName: 'Spanish',
    shortLangPrefix: 'es',
    i18nKey: 'es-LA',
    urlLangPrefix: 'es/',
    languageId: 'ES'
  },
  nl: {
    name: 'Nederlands',
    englishName: 'Dutch',
    shortLangPrefix: 'nl',
    i18nKey: 'nl',
    urlLangPrefix: 'nl/',
    languageId: 'NL'
  },
  da: {
    name: 'Dansk',
    englishName: 'Danish',
    shortLangPrefix: 'da',
    i18nKey: 'da',
    urlLangPrefix: 'da/',
    languageId: 'DA'
  },
  sv: {
    name: 'Svenska',
    englishName: 'Swedish',
    shortLangPrefix: 'sv',
    i18nKey: 'SV-se',
    urlLangPrefix: 'sv/',
    languageId: 'SV'
  },
  ru: {
    name: 'Pусский',
    englishName: 'Russian',
    shortLangPrefix: 'ru',
    i18nKey: 'ru',
    urlLangPrefix: 'ru/',
    languageId: 'RU'
  },
  it: {
    name: 'Italiano',
    englishName: 'Italian',
    shortLangPrefix: 'it',
    i18nKey: 'it-IT',
    urlLangPrefix: 'it/',
    languageId: 'IT'
  }
} as I18nLanguages;

export default languages;
